export default {
  pageNotFound: "La page que vous recherchez n'existe pas.",
  generic: {
    title: "Quelque chose d'inattendu c'est produit",
    subtitle: "On dirait qu'on s'est perdu en cours de route",
  },
  newApplication: 'Débuter une nouvelle application',
};
